<template>
  <v-row no-gutters ref="home" class="home">
    <v-col cols="12">
      <section id="banner-video" class="black">
        <div class="banner-image secondary">
          <!-- <v-img :src="banner_image" width="100%" height="100%"></v-img> -->
          <div class="banner-container primary--text">
            <div class="banner-heading">Cinematic Celebration</div>
            <div class="banner-description primary--text">
              At Cinematic Celebration, we're dedicated to crafting
              unforgettable celebrations. Our affordable yet stylish venues are
              perfect for any occasion. With a focus on customer happiness and
              flexibility, we make your moments truly special. Join our
              community of celebrators today!
            </div>
            <div class="banner-action">
              <v-btn color="yellow" flat large class="mr-2">
                <a
                  class="primary--text"
                  style="text-decoration: none"
                  href="tel:+917411148005"
                >
                  Call Us
                </a>
              </v-btn>

              <v-btn
                :to="{ name: 'BookOnline', params: { location: 'hulimavu' } }"
                color="yellow"
                flat
                large
                class="ml-2"
              >
                Book Now
              </v-btn>
              <!-- <v-btn
                 :to="{ name: 'BookOnline', params: { location: 'hulimavu' } }"
                color="yellow"
                flat
                large
                class="ml-2"
              >
                Book Now
              </v-btn> -->
            </div>
          </div>
        </div>
      </section>
    </v-col>

    <v-col cols="12">
      <section id="about-us" class="about-us text-left secondary darken-1">
        <v-container>
          <v-card flat color="transparent" class="pa-5">
            <v-row no-gutters class="fill-height" justify="center">
              <v-col cols="12" lg="8" md="8" sm="8">
                <v-card
                  class="pa-lg-5 pa-md-5 pa-sm-3 text-center"
                  color="secondary darken-1"
                  flat
                >
                  <!-- <div class="about-us-title brown--text">ABOUT US</div> -->
                  <div class="about-us-heading primary--text">About Us</div>
                  <!-- <div class="about-us-description lightgrey--text">
                    At Cinematic Celebration, we believe that every moment in life is
                    worth celebrating, and we're here to make those moments
                    truly unforgettable.
                  </div> -->
                  <div
                    class="about-us-description secondary darken-1 primary--text"
                  >
                    "At Cinematic Celebration, we're passionate about turning
                    life's moments into unforgettable celebrations. With a
                    diverse range of celebration spaces, exceptional service,
                    and affordable luxury starting from just RS. 499/-, we're
                    dedicated to making your milestones shine. As a
                    customer-centric community of celebrators, we prioritize
                    your happiness and are ready to create tailor-made,
                    resounding successes for your special events. Join us in
                    transforming your occasions into cherished memories. Contact
                    us today to book your next unforgettable celebration at
                    Cinematic Celebration."
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-container>
      </section>
    </v-col>

    <!-- <v-col cols="12">
      <section id="how-it-works" class="how-it-works">
        <v-container>
          <v-card height="" color="primary" raised class=""> </v-card>
        </v-container>
      </section>
    </v-col> -->

    <!-- <v-col cols="12">
      <section id="our-space" class="our-space secondary">
        <v-container fluid>
          <v-row class="justify-center">
            <v-col
              cols="12"
              lg="4"
              offset-lg="2"
              offset-md="2"
              align-items="center"
            >
              <div class="text-left pr-lg-16 pr-md-16">
                <div class="our-space-title white--text">our space</div>
                <div class="our-space-heading primary--text">
                  Joyful experiences for you and your family
                </div>
                <div class="our-space-description white--text">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,
                  vero dolor asperiores veniam distinctio assumenda est!
                  Reprehenderit omnis minus dolor corrupti accusantium? Laborum
                  earum quam consequatur consectetur similique ad laboriosam.
                  <br />
                  <br />
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                  Natus mollitia saepe sit tempora molestiae magnam voluptates
                  provident cupiditate sunt impedit. Reiciendis nihil dolorum
                  nobis adipisci aliquam doloribus recusandae harum sit.
                </div>
              </div>
            </v-col>
            <v-col cols="12" lg="6" md="6">
              <v-row>
                <v-col cols="12" lg="6" md="6" sm="6">
                  <div>
                    <v-card
                      color="lightpink"
                      raised
                      style="
                        background-size: cover;
                        background-position: center;
                      "
                      :style="{
                        'background-image': `url(${our_space.image1})`,
                      }"
                      min-height="350"
                    >
                    </v-card>
                    <v-card color="brown" raised tile>
                      <v-row no-gutters justify="center" class="fill-height">
                        <v-col cols="12" align-self="center" class="text-left">
                          <div class="service-content primary--text">
                            <div class="service-title">Plan 1</div>

                            <div class="text-center">
                              <v-btn
                                small
                                color="primary"
                                class="brown--text"
                                :to="{
                                  name: 'BookOnline',
                                  params: { selectedPlanId: 2 },
                                }"
                              >
                                Book now at Rs299
                              </v-btn>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </div>
                </v-col>

                <v-col cols="12" lg="6" md="6" sm="6">
                  <div>
                    <v-card
                      color="lightpink"
                      raised
                      style="
                        background-size: cover;
                        background-position: center;
                      "
                      :style="{
                        'background-image': `url(${our_space.image2})`,
                      }"
                      min-height="350"
                    ></v-card>
                    <v-card color="brown" hover tile>
                      <v-row no-gutters justify="center" class="fill-height">
                        <v-col cols="12" align-self="center" class="text-left">
                          <div class="service-content primary--text">
                            <div class="service-title">Plan 2</div>

                            <div class="text-center">
                              <v-btn
                                small
                                color="primary"
                                class="brown--text"
                                :to="{
                                  name: 'BookOnline',
                                  params: { selectedPlanId: 1 },
                                }"
                              >
                                Book now at Rs399
                              </v-btn>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </div>
                </v-col>

                <v-col cols="12" lg="6" md="6" sm="6">
                  <div>
                    <v-card
                      color="lightpink"
                      raised
                      style="
                        background-size: cover;
                        background-position: center;
                      "
                      :style="{
                        'background-image': `url(${our_space.image3})`,
                      }"
                      min-height="350"
                    >
                    </v-card>
                    <v-card color="brown" hover tile>
                      <v-row no-gutters justify="center" class="fill-height">
                        <v-col cols="12" align-self="center" class="text-left">
                          <div class="service-content primary--text">
                            <div class="service-title">Plan 3</div>
                            <div class="text-center">
                              <v-btn
                                small
                                color="primary"
                                class="brown--text"
                                :to="{
                                  name: 'BookOnline',
                                  params: { selectedPlanId: 2 },
                                }"
                              >
                                Book Now at Rs499
                              </v-btn>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </div>
                </v-col>
                <v-col cols="12" lg="6" md="6" sm="6">
                  <div>
                    <v-card
                      color="lightpink"
                      raised
                      style="
                        background-size: cover;
                        background-position: center;
                      "
                      :style="{
                        'background-image': `url(${our_space.image4})`,
                      }"
                      min-height="350"
                    >
                    </v-card>
                    <v-card color="brown" hover tile>
                      <v-row no-gutters justify="center" class="fill-height">
                        <v-col cols="12" align-self="center" class="text-left">
                          <div class="service-content primary--text">
                            <div class="service-title">Plan 4</div>

                            <div class="text-center">
                              <v-btn
                                small
                                color="primary"
                                class="brown--text"
                                :to="{
                                  name: 'BookOnline',
                                  params: { selectedPlanId: 2 },
                                }"
                              >
                                Book Now at Rs799
                              </v-btn>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </section>
    </v-col> -->

    <v-col cols="12">
      <section id="our-space" class="our-space secondary">
        <v-container fluid>
          <v-row class="justify-center">
            <v-col cols="12" lg="12" md="12">
              <v-row no-gutters>
                <v-col cols="12">
                  <div class="our-space-heading primary--text">Our Space</div>
                </v-col>
                <v-col cols="12" lg="3" md="3" sm="4">
                  <div class="pa-3 pa-lg-8 pa-md-8 pa-sm-8">
                    <v-card
                      color="black"
                      raised
                      style="
                        background-size: cover;
                        background-position: center;
                      "
                      :style="{
                        'background-image': `url(${our_space.image1})`,
                      }"
                      min-height="450"
                      class="our-space-card"
                    >
                    </v-card>
                    <v-card color="transparent" tile flat>
                      <v-row no-gutters justify="center" class="fill-height">
                        <v-col cols="12" align-self="center" class="text-left">
                          <div class="service-content primary--text">
                            <div class="service-title">Red Love</div>
                            <div class="service-description">
                              Experience romantic and intimate celebrations in
                              our 6ft heart-shaped decor adorned with red
                              balloons, personalized neon lighting, and a cozy
                              sofa seating arrangement, offering 100% privacy
                              for couples and small groups of up to 4 people.
                              Enjoy the ambiance with wall lighting, a cake
                              stand, customized LED name board, and decorative
                              props, perfect for occasions like birthdays,
                              anniversaries, bridal showers, farewells, and
                              more.
                            </div>

                            <div class="service-action">
                              <router-link
                                class="primary--text"
                                :to="{
                                  name: 'BookOnline',
                                  params: { location: 'hulimavu' },
                                }"
                              >
                                Book now at Rs. 499/-
                              </router-link>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </div>
                </v-col>

                <v-col cols="12" lg="3" md="3" sm="4">
                  <div class="pa-3 pa-lg-8 pa-md-8 pa-sm-8">
                    <v-card
                      color="black"
                      raised
                      style="
                        background-size: cover;
                        background-position: center;
                      "
                      :style="{
                        'background-image': `url(${our_space.image2})`,
                      }"
                      min-height="450"
                      class="our-space-card"
                    ></v-card>
                    <v-card color="transparent" tile flat>
                      <v-row no-gutters justify="center" class="fill-height">
                        <v-col cols="12" align-self="center" class="text-left">
                          <div class="service-content primary--text">
                            <div class="service-title">Peachy Glam</div>
                            <div class="service-description">
                              Adorned with soft pink and rose gold balloons for
                              an elegant touch. • Enchanting 4-feet circle
                              shaped decor • Cozy private seating for up to 6
                              guests, perfect for intimate celebrations. •
                              Immersive ambiance with fog effects, creating a
                              dreamy atmosphere. • Premium amenities: cake
                              stand, customized LED name board • Space offers
                              projection and HD screen • Pre-installed OTT apps
                              for entertainment • Wall lighting for a memorable
                              event
                            </div>

                            <div class="service-action">
                              <router-link
                                class="primary--text"
                                :to="{
                                  name: 'BookOnline',
                                  params: { location: 'hulimavu' },
                                }"
                              >
                                Book now at Rs. 799/-
                              </router-link>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </div>
                </v-col>

                <v-col cols="12" lg="3" md="3" sm="4">
                  <div class="pa-3 pa-lg-8 pa-md-8 pa-sm-8">
                    <v-card
                      color="black"
                      raised
                      style="
                        background-size: cover;
                        background-position: center;
                      "
                      :style="{
                        'background-image': `url(${our_space.image3})`,
                      }"
                      min-height="450"
                      class="our-space-card"
                    >
                    </v-card>
                    <v-card color="transparent" tile flat>
                      <v-row no-gutters justify="center" class="fill-height">
                        <v-col cols="12" align-self="center" class="text-left">
                          <div class="service-content primary--text">
                            <div class="service-title">Lavender Retreat</div>
                            <div class="service-description">
                              • A dreamy setup with soft lavender and deep
                              purple balloons for a magical touch. • Stunning
                              butterfly-themed cake stand and decor for a
                              fairytale vibe. • Private space accommodates up to
                              8 guests • Backdrop neon lights adapt to your
                              occasion's theme • Sophisticated ambiance •
                              Premium amenities: cake stand, customized LED name
                              board • Projection screen & pre-installed OTT apps
                              for an immersive entertainment experience. •
                              Immersive ambiance with fog effects, creating a
                              dreamy atmosphere.
                            </div>

                            <div class="service-action">
                              <router-link
                                class="primary--text"
                                :to="{
                                  name: 'BookOnline',
                                  params: { location: 'hulimavu' },
                                }"
                              >
                                Book now at Rs. 999/-
                              </router-link>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </div>
                </v-col>

                <v-col cols="12" lg="3" md="3" sm="4">
                  <div class="pa-3 pa-lg-8 pa-md-8 pa-sm-8">
                    <v-card
                      color="black"
                      raised
                      style="
                        background-size: cover;
                        background-position: center;
                      "
                      :style="{
                        'background-image': `url(${our_space.image4})`,
                      }"
                      min-height="450"
                      class="our-space-card"
                    >
                    </v-card>
                    <v-card color="transparent" tile flat>
                      <v-row no-gutters justify="center" class="fill-height">
                        <v-col cols="12" align-self="center" class="text-left">
                          <div class="service-content primary--text">
                            <div class="service-title">Cinematic Royalty</div>
                            <div class="service-description">
                              • Luxurious blue and gold balloon décor for a
                              grand and elegant vibe. • A magical fog effect
                              with glowing lights creates a dreamy atmosphere. •
                              Backdrop neon lights adapt to your occasion's
                              theme • Cozy private lounge seating for up to 10
                              guests, ensuring a comfortable celebration. •
                              Premium amenities: cake stand, customized LED name
                              board • Cinematic experience with a projection
                              screen and pre-installed OTT apps. • Premium
                              gold-themed decor, including lanterns and a
                              carousel centerpiece for a regal touch. • Perfect
                              for birthdays, milestone celebrations, and
                              exclusive gatherings!
                            </div>

                            <div class="service-action">
                              <router-link
                                class="primary--text"
                                :to="{
                                  name: 'BookOnline',
                                  params: { location: 'hulimavu' },
                                }"
                              >
                                Book now at Rs. 1299/-
                              </router-link>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </section>
    </v-col>

    <v-col cols="12">
      <section id="contact-us" class="contact-us">
        <v-row no-gutters justify="center">
          <!-- <v-col cols="12" class="align-self-center">
            <div class="contact-us-heading primary--text">Visit Us</div>
          </v-col> -->
          <v-col cols="12" lg="6" md="5" class="align-self-center">
            <div class="contact-us-heading primary--text">Visit Us</div>
            <v-card color="secondary" flat tile class="contact-us-cards">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.4362817660863!2d77.5934650108159!3d12.879644016834977!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae155387af850d%3A0xea726a097976e0cf!2sCinematic%20Celebration!5e0!3m2!1sen!2sin!4v1741540657226!5m2!1sen!2sin"
                width="90%"
                height="450"
                style="border: 0"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </v-card>
          </v-col>

          <v-col cols="12" lg="6" md="7">
            <div class="contact-us-heading">Contact Us</div>
            <v-card
              color="secondary"
              flat
              tile
              class="contact-us-cards primary--text fill-height"
            >
              <contact-form></contact-form>
            </v-card>
          </v-col>
        </v-row>
      </section>
    </v-col>
  </v-row>
</template>

<script>
// @ is an alias to /src
import ContactForm from "@/components/ContactForm.vue";
export default {
  name: "HomeView",
  components: {
    ContactForm,
  },
  mounted() {
    if (this.$route.hash) {
      this.$vuetify.goTo(this.$route.hash, {
        duration: 750,
        offset: 0,
      });
    } else {
      this.$vuetify.goTo(0, {
        duration: 750,
        offset: 0,
      });
    }
  },
  watch: {
    "$route.hash": {
      handler: function (val) {
        if (val) {
          this.$vuetify.goTo(val, { duration: 1000, offset: 0 });
        } else {
          this.$vuetify.goTo(0, {
            duration: 1000,
            offset: 0,
          });
        }
      },
    },
  },
  data() {
    return {
      // bannerVideoMp4: require("@/assets/video/bannerVideo.mp4"),
      // bannerVideoWebm: require("@/assets/video/bannerVideo.webm"),
      // bannerVideo: require("@/assets/video/bannerVideo.gif"),
      // bannerVideoMobile: require("@/assets/video/bannerVideoMobile.gif"),
      banner_image:
        "https://happyharbourbucket.s3.ap-south-1.amazonaws.com/banner.jpg",
      our_space: {
        image1: require("@/assets/gallery/1/2.jpg"),
        image2: require("@/assets/gallery/2/1.jpg"),
        image3: require("@/assets/gallery/3/1.jpg"),
        image4: require("@/assets/gallery/4/1.jpg"),
      },
    };
  },
  methods: {
    scrollTo(id) {
      this.$router.push({ name: "HomeView", hash: id });
    },
  },
};
</script>
<style scoped>
.home .banner-video {
  position: relative;
  height: calc(100vh - 64px);
  width: 100%;
}

.home .banner-video .banner-text {
  color: white;
  font-size: 50px;
  font-weight: 700;
  position: absolute;
  top: 70%;
  left: 15%;
  transform: translate(-15%, -70%);
}

.home .banner-video .banner-button {
  position: absolute;
  top: 95%;
  left: 50%;
  transform: translate(-50%, -95%);
}

.home .banner-video .banner-text h1 {
  line-height: 1;
}

.home .banner-video .banner-text h3 {
  margin-left: 10px;
}

.home .banner-image {
  position: relative;
  height: calc(100vh - 64px);
  width: 100%;
  /* background-image: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0.5)
    ),
    url("../assets/banner.jpg"); */
  background-image: url("../assets/banner_new.webp");
  background-size: cover;
}

.home .banner-container {
  position: absolute;
  width: 30%;
  top: 70%;
  left: 80%;
  transform: translate(-80%, -70%);
  text-align: left;
  padding: 30px;
  /* border: 20px solid #ccdad1; */
  border: 20px solid #ebc363;
}
.home .banner-container .banner-heading {
  font-size: 50px;
  font-weight: 700;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.45);
}
.home .banner-container .banner-description {
  margin: 25px 0;
  font-size: 18px;
  line-height: 1.5;
  word-wrap: break-word;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
  font-style: italic;
}

.home .about-us,
.home .our-space,
.home .testimonial,
.home .contact-us {
  padding: 100px 0;
}

.home .about-us .about-us-title,
.home .our-space .our-space-title,
.home .testimonial .testimonial-title,
.home .contact-us .contact-us-title {
  font-size: 24px;
  line-height: 28px;
  font-weight: 300;
  text-transform: uppercase;
  /* letter-spacing: 2px; */
  margin-bottom: 22px;
}

.home .about-us .about-us-heading,
.home .our-space .our-space-heading,
.home .testimonial .testimonial-heading,
.home .contact-us .contact-us-heading {
  font-size: 48px;
  line-height: 52px;
  font-weight: 700;
  margin-bottom: 30px;
}

.home .our-space .our-space-card {
  border: 4px solid;
}
.home .our-space .our-space-description {
  font-size: 16px;
  line-height: 25px;
}
.home .about-us .about-us-description {
  font-size: 18px;
  line-height: 30px;
  margin-bottom: 20px;
  font-weight: 500;
  font-style: italic;
}

.home .about-us .about-us-image {
  height: 250px;
  background-position: center;
}

.home .about-us .about-us-image.image3 {
  height: 508px;
}

.home .testimonial .review-image {
  background-position: top;
}

.home .testimonial .review-image,
.home .about-us .about-us-image {
  background-repeat: no-repeat;
  background-size: cover;
}

.home .our-space .service-content {
  padding: 32px 0;
  text-align: left;
}

.home .our-space .service-title {
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 2px;
  font-weight: 700;
}
.home .our-space .service-description {
  font-size: 16px;
  line-height: 28px;
  letter-spacing: 1.2px;
  font-style: italic;
  font-weight: 500;
  margin: 20px 0;
}
.home .our-space .service-action a {
  font-size: 16px;
  line-height: 28px;
  letter-spacing: 1.2px;
  font-style: italic;
  font-weight: 500;
  margin: 20px 0;
  text-decoration: none;
  padding-bottom: 4px;
  border-bottom: 2px solid;
}
.home .contact-us-cards {
  padding: 60px 0;
}

@media only screen and (max-width: 1024px) {
  .home .banner-container {
    width: 45%;
  }
}

@media only screen and (max-width: 600px) {
  .home .banner-container {
    position: relative;
    width: 90%;
    margin: auto;
    top: 70%;
    left: 0%;
    transform: translate(0%, -70%);
    padding: 15px;
    border: 10px solid #ccdad1;
  }
  .home .banner-container .banner-heading {
    font-size: 40px;
  }
  .home .banner-container .banner-description {
    margin: 25px 0;
    font-size: 18px;
  }
  .home .about-us .about-us-image {
    height: 120px;
  }

  .home .about-us .about-us-image.image3 {
    height: 248px;
  }
}

@media only screen and (max-width: 960px) {
  .home .banner-video {
    height: calc(100vh - 56px);
  }

  .home .banner-video .banner-text {
    font-size: 30px;
  }

  .home .about-us,
  .home .our-space,
  .home .testimonial,
  .home .contact-us {
    padding: 50px 0;
  }

  .home .about-us .about-us-heading,
  .home .our-space .our-space-heading,
  .home .testimonial .testimonial-heading,
  .home .contact-us .contact-us-heading {
    font-size: 24px;
    line-height: 34px;
    margin-bottom: 30px;
  }

  .home .about-us .about-us-description {
    font-size: 16px;
    line-height: 26px;
    margin-bottom: 20px;
  }
}
</style>
